import { render, staticRenderFns } from "./EntityForm.vue?vue&type=template&id=1639d3a1&scoped=true&"
import script from "./EntityForm.vue?vue&type=script&lang=ts&"
export * from "./EntityForm.vue?vue&type=script&lang=ts&"
import style0 from "./EntityForm.vue?vue&type=style&index=0&id=1639d3a1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1639d3a1",
  null
  
)

export default component.exports